/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Woman = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Woman"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#8E00E5"
      fillRule="evenodd"
      d="M12 2c3.59 0 6.5 2.985 6.5 6.667 0 3.106-2.072 5.716-4.875 6.456v1.044h.813c.897 0 1.624.746 1.624 1.666s-.727 1.667-1.625 1.667h-.812v.833c0 .92-.727 1.667-1.625 1.667s-1.625-.746-1.625-1.667V19.5h-.812c-.898 0-1.626-.746-1.626-1.667 0-.92.728-1.666 1.625-1.666h.813v-1.044c-2.803-.74-4.875-3.35-4.875-6.456C5.5 4.985 8.41 2 12 2m-.812 12.44-.038-.005zm1.624-.001v.002l.037-.007zm-2.437-.18-.029-.01q.015.004.029.01m3.278-.01-.028.01zM12 5.333c-1.795 0-3.25 1.493-3.25 3.334S10.205 12 12 12s3.25-1.492 3.25-3.333S13.795 5.333 12 5.333"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const WomanIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'woman-icon'}
      icon={Woman}
      {...props}
      size={size}
    />
  );
};
